/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesInviteEmailInviteRequest interface.
 */
export function instanceOfFxIdWebFeaturesInviteEmailInviteRequest(value) {
    if (!('Email' in value) || value['Email'] === undefined)
        return false;
    if (!('CaptchaResult' in value) || value['CaptchaResult'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesInviteEmailInviteRequestFromJSON(json) {
    return FxIdWebFeaturesInviteEmailInviteRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesInviteEmailInviteRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Email': json['Email'],
        'GameSystemName': json['GameSystemName'] == null ? undefined : json['GameSystemName'],
        'Game': json['Game'] == null ? undefined : json['Game'],
        'CaptchaResult': json['CaptchaResult'],
    };
}
export function FxIdWebFeaturesInviteEmailInviteRequestToJSON(json) {
    return FxIdWebFeaturesInviteEmailInviteRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesInviteEmailInviteRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Email': value['Email'],
        'GameSystemName': value['GameSystemName'],
        'Game': value['Game'],
        'CaptchaResult': value['CaptchaResult'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesInviteEmailInviteRequest.js.map